import { ApiError } from '../api/client';

/** Same 403/400/fallback idiom `arca-config-api-errors.ts`'s `genericApiErrorMessage` already applies. */
function genericApiErrorMessage(error: ApiError): string {
  if (error.status === 403) {
    return 'No tenés permiso para realizar esta acción.';
  }

  if (error.status === 400) {
    return 'Revisá los datos ingresados e intentá de nuevo.';
  }

  return 'Ocurrió un error inesperado. Intentá de nuevo.';
}

/** Codes from `apps/api` `RolesExceptionFilter` (`roles-exception.filter.ts`). */
export function mapRoleError(error: unknown): string {
  if (error === undefined || error === null) {
    return '';
  }

  if (!(error instanceof ApiError)) {
    return 'Ocurrió un error de conexión. Intentá de nuevo.';
  }

  const code = (error.body as { code?: string } | null)?.code;

  if (code === 'PRIVILEGE_ESCALATION') {
    return 'No podés otorgar permisos que vos mismo no tenés.';
  }

  if (code === 'FORBIDDEN_ROLE_PERMISSION') {
    return 'Ese permiso no se puede asignar a un rol personalizado.';
  }

  if (code === 'ROLE_SYSTEM_IMMUTABLE') {
    return 'Los roles del sistema no se pueden editar ni eliminar.';
  }

  if (code === 'ROLE_CODE_DUPLICATE') {
    return 'Ya existe un rol con ese código.';
  }

  if (code === 'ROLE_HAS_USERS') {
    return 'No se puede eliminar: el rol tiene usuarios asignados. Quitá la asignación antes de eliminarlo.';
  }

  if (code === 'UNKNOWN_PERMISSION_CODE') {
    return 'Uno de los permisos seleccionados no existe.';
  }

  if (code === 'ROLE_NOT_FOUND') {
    return 'El rol no existe o fue eliminado.';
  }

  return genericApiErrorMessage(error);
}
